import React, { useState } from 'react';
import classNames from 'classnames';
import { Link } from '../../components/Link';
import Arrow from '../../components/Arrow';
import ExposureContainer from '../../components/ExposureContainer';
import styles from './RefuteFeedback.module.scss';

interface Props {
  title?: string; // 标题文案
  desc?: string; // 描述文案
  btnText?: string; // 按钮文案
  linkUrl?: string; // 按钮跳转链接
  decorationImgPc?: string; // 装饰背景图（PC 端展示）
  decorationImgH5?: string; // 装饰背景图（H5 端展示）
}

/**
 * 辟谣公告页 - 不实信息举报反馈模块
 * 展示举报入口标题、描述文案以及跳转反馈表单的按钮
 * PC 端常驻渐变卡片样式；H5 端默认透明背景，进入视口后触发渐显过渡动画
 */
const RefuteFeedback = (props: Props) => {
  const { title, desc, btnText, linkUrl = '', decorationImgPc, decorationImgH5 } = props;
  const [visible, setVisible] = useState(false);

  const handleExpose = () => {
    setVisible(true);
  };

  return (
    <ExposureContainer isAlways={false} onExpose={handleExpose} className={styles['feedback-outside']}>
      <div className={styles['feedback-expose']}>
        <section className={`${styles['feedback-box']} ${visible ? styles['feedback-box-visible'] : ''}`}>
          <div
            className={styles['feedback-decoration']}
            style={
              {
                '--decoration-h5': decorationImgH5 ? `url(${decorationImgH5})` : 'none',
                '--decoration-pc': decorationImgPc ? `url(${decorationImgPc})` : 'none',
              } as any
            }
          />
          <div className={styles['feedback-content']}>
            <h2 className={classNames(styles['feedback-title'], 'mt-font')}>{title}</h2>
            <p className={styles['feedback-desc']}>{desc}</p>
          </div>
          <Link href={linkUrl || ''} legacyBehavior scroll={false} prefetch={false}>
            <a className={styles['feedback-btn']} target="_blank">
              <span className={styles['feedback-btn-text']}>{btnText}</span>
              <Arrow className={styles['feedback-btn-arrow']} />
            </a>
          </Link>
        </section>
      </div>
    </ExposureContainer>
  );
};

RefuteFeedback.displayName = 'RefuteFeedback';
export default RefuteFeedback;
